import React from "react";

interface GridTableProps {
    children?: React.ReactNode;
    className?: string;
    id?: string;
    parentClass?: string;
    style?: React.CSSProperties;
}

export const GridTable: React.FC<GridTableProps> = ({className="", children, id="", parentClass=""}: GridTableProps) => {
    return <div aria-live="polite" className={`table-scroll ${parentClass}`} id={id}>
        <table className={className}>{children}</table>
    </div>;
};
